import { DataStore } from '../stores';

export const fundListFilter = (
    config: { key?: string },
    dataStore: DataStore,
    shareClass
) => {
    const identifier = shareClass?.clientCode;
    const linkFilter: any = dataStore.fundLinkFilter;
    // make sure a unique key is set up
    const key = config.key;

    if (linkFilter && linkFilter[key]) {
        if (!identifier) {
            return false;
        }
        return linkFilter[key].indexOf(identifier) > -1;
    }
    return true;
};



// WEBPACK FOOTER //
// ./src/utils/fundListFilter.ts